import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { features, feature } from "../data/site";

const pillars = [
  {
    n: "01",
    title: "Antique Gold Mastery",
    text: "Traditional 22K antique gold work — nakashi, jadau and hand-finishing — kept alive by our master karigars.",
  },
  {
    n: "02",
    title: "Hallmarked Purity",
    text: "Every piece is hallmarked and quality-assured, so the gold you cherish is exactly as promised.",
  },
  {
    n: "03",
    title: "Bespoke by Design",
    text: "Commissions designed in collaboration with you — a singular heirloom, made entirely to your vision.",
  },
];

export default function About() {
  return (
    <>
      <PageHero
        eyebrow="The House"
        title="A house built on heritage"
        subtitle="Culture Antique Jewellery — where generations of craftsmanship meet the timeless beauty of antique gold, in the heart of Ahmedabad."
        image={feature.heroAbout}
      />

      {/* Story */}
      <section className="py-16 md:py-28">
        <div className="container-luxe grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
          <Reveal className="overflow-hidden">
            <img
              src={feature.legacy}
              alt="Culture Antique craftsmanship"
              className="h-[420px] w-full object-cover sm:h-[520px] lg:h-[600px]"
            />
          </Reveal>
          <Reveal delay={150}>
            <p className="eyebrow mb-5">Our Story</p>
            <h2 className="section-title mb-8">
              Legacies in the <span className="italic text-gold-dark">making</span>
            </h2>
            <div className="space-y-5 font-sans text-base font-light leading-relaxed text-charcoal/70">
              <p>
                Culture Antique was founded on a simple conviction: that fine
                jewellery should be more than adornment — it should be an heirloom,
                a story carried across generations.
              </p>
              <p>
                Our atelier brings together master karigars and the age-old
                traditions of antique gold craftsmanship. Temple motifs, uncut
                kundan, and intricate hand-work come together in jewellery of
                quiet, enduring distinction.
              </p>
              <p>
                From the first sketch to the final polish, every creation is made by
                hand and made to last — a piece you will be proud to pass on.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Pillars */}
      <section className="border-y border-gold/15 bg-cream py-16 md:py-24">
        <div className="container-luxe">
          <Reveal className="mb-12 text-center md:mb-16">
            <p className="eyebrow mb-5">What Sets Us Apart</p>
            <h2 className="section-title">The Culture Antique standard</h2>
          </Reveal>
          <div className="grid gap-12 md:grid-cols-3">
            {pillars.map((p, i) => (
              <Reveal key={p.n} delay={i * 120}>
                <span className="font-serif text-5xl font-light text-gold/40">{p.n}</span>
                <h3 className="mb-3 mt-4 font-serif text-2xl font-semibold tracking-wide text-gilt md:text-3xl">
                  {p.title}
                </h3>
                <div className="mb-4 h-px w-10 bg-gold/50" />
                <p className="font-sans text-sm font-light leading-relaxed text-charcoal/60">
                  {p.text}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Promises */}
      <section className="py-16 md:py-24">
        <div className="container-luxe">
          <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
            {features.map((f, i) => (
              <Reveal key={f.title} delay={i * 90}>
                <div className="hairline mb-5" />
                <h3 className="mb-2 font-serif text-xl font-light text-charcoal">{f.title}</h3>
                <p className="font-sans text-sm font-light leading-relaxed text-charcoal/60">
                  {f.text}
                </p>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-16 text-center">
            <Link to="/contact" className="btn-gold">
              Visit the Showroom
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
